import apiClient from '../Api';
import {
  buildEntityDisplayUpdatePayload,
  buildEntityRenamePayload
} from '../../features/panel-planning/utils/panelEntityNumbering.js';

/**
 * 모듈 관련 API 함수들 (Spring Data REST: /api/solarModules)
 */

// 모듈 위치 업데이트 (shapeGeog 갱신)
export const updatePosition = async (moduleId, newPosition) => {
  try {
    console.log(`🔄 모듈 ${moduleId} 위치 업데이트:`, newPosition);
    const response = await apiClient.update(`/solarModules/${moduleId}`, {
      shapeGeog: newPosition,
      centerCoord: newPosition?.centerCoord || null
    });
    return response.data;
  } catch (error) {
    console.error('모듈 위치 업데이트 실패:', error);
    throw error;
  }
};

// 모듈 이름/표시 번호 업데이트 — "Module 5" → { moduleId: "5", name: "Module 5" }
export const updateName = async (moduleId, newName, options = {}) => {
  try {
    const payload =
      options.displayId != null
        ? buildEntityDisplayUpdatePayload('module', {
            name: newName,
            displayId: options.displayId
          })
        : buildEntityRenamePayload('module', newName);
    if (!payload.moduleId && !payload.name) {
      throw new Error('newName is required for module rename');
    }
    console.log(`🔄 모듈 ${moduleId} 이름 업데이트:`, payload);
    const response = await apiClient.update(`/solarModules/${moduleId}`, payload);
    return response.data;
  } catch (error) {
    console.error('모듈 이름 업데이트 실패:', error);
    throw error;
  }
};

// 모듈을 새로운 String으로 이동
// Spring Data REST association: PUT /solarModules/{id}/solarString (text/uri-list)
export const moveToNewString = async (moduleId, targetStringId) => {
  try {
    console.log(`🔄 모듈 ${moduleId}를 String ${targetStringId}로 이동`);
    const { authHeader } = await import('../../_helpers');
    const axios = (await import('axios')).default;
    const _apiUrl = (process.env.VUE_APP_DOMAIN || '') + process.env.VUE_APP_API_URL;
    const response = await axios({
      method: 'put',
      url: `${_apiUrl}/solarModules/${moduleId}/solarString`,
      headers: {
        Authorization: authHeader(),
        'Content-Type': 'text/uri-list'
      },
      data: `/api/solarStrings/${targetStringId}`
    });
    return response.data;
  } catch (error) {
    console.error('모듈 이동 실패:', error);
    throw error;
  }
};

// 대량 모듈 업데이트 — 순차 PATCH
export const bulkUpdate = async moduleUpdates => {
  try {
    console.log('🔄 대량 모듈 업데이트:', moduleUpdates);
    const results = [];
    for (const { id, ...data } of moduleUpdates) {
      const response = await apiClient.update(`/solarModules/${id}`, data);
      results.push(response.data);
    }
    return { success: true, updatedCount: results.length, results };
  } catch (error) {
    console.error('대량 모듈 업데이트 실패:', error);
    throw error;
  }
};

export const moduleApi = {
  updatePosition,
  updateName,
  moveToNewString,
  bulkUpdate
};
